module.exports = __webpack_public_path__ + "img/max-file-deny.e8bb9f3d.svg";